import React, { useState, useEffect } from "react"
import Layout from "../../components/layouts/layout"
import Select from "react-select"
import PropTypes from "prop-types"
import { getSelectOptions } from "../../components/blocks/form/utils"
import { useTrackFormStepArrival } from "../../utils/analytics"
import ContinueButton from "components/elements/styledButton/ContinueButton"
import ProgressBar from "utils/stepper"
import MorningApptBanner from "utils/morningApptBanner"

const Corticacenter = ({ nextStep, prevStep, setUser, user }) => {
  useTrackFormStepArrival("cortica_center")
  const excludedClinic = "ca/san-diego/mission-valley"
  const options = getSelectOptions("Clinics", "", excludedClinic)
  const leadSourceWithInput = ["other", "medical provider", "school"]
  const leadSourceOptions = [
    { value: "facebook/instagram", label: "Facebook/Instagram" },
    { value: "insurance", label: "Insurance" },
    { value: "internet search", label: "Internet Search" },
    { value: "tv/radio", label: "TV/Radio" },
    { value: "friend", label: "Friend" },
    { value: "school", label: "School" },
    { value: "childcare provider", label: "Childcare Provider" },
    { value: "cortica staff", label: "Cortica Staff" },
    { value: "medical provider", label: "Medical Provider" },
    { value: "other", label: "Other" },
  ]
  options.push({
    id: "",
    label: "Not Sure",
    value: "Not Sure",
  })
  const [nextBtn, setNextbtn] = useState(false)
  const [showOtherInput, setShowOtherInput] = useState(false)
  const [errField, setErrField] = useState({
    findAFacilityErr: "",
    leadSourceErr: "",
    leadSourceDetailErr: "",
  })

  const validForm = () => {
    let formIsvalid = true
    setErrField({
      findAFacilityErr: "",
      leadSourceErr: "",
      leadSourceDetailErr: "",
    })

    if (user.findAFacility === "" || user.leadSource === "") {
      formIsvalid = false
      setErrField(prevState => ({
        ...prevState,
        findAFacilityErr: "please Select Facility.",
        leadSourceErr: "please select an option",
      }))
    }

    if (
      leadSourceWithInput.includes(user.leadSource) &&
      (!user.leadSourceDetail || user.leadSourceDetail.trim() === "")
    ) {
      formIsvalid = false
      setErrField(prevState => ({
        ...prevState,
        leadSourceDetailErr:
          "please provide additional details on how you heard about us",
      }))
    }

    return formIsvalid
  }

  const handleChange = e => {
    setUser({
      ...user,
      findAFacility: e.value,
    })
  }

  const handleLeadSource = e => {
    const selectedValue = e.value
    const shouldResetInput = !leadSourceWithInput.includes(selectedValue)

    setUser({
      ...user,
      leadSource: selectedValue,
      ...(shouldResetInput && { leadSourceDetail: "" }),
    })

    setShowOtherInput(leadSourceWithInput.includes(selectedValue))
  }

  const handleLeadSourceDetail = e => {
    const additionalText = e.target.value
    setUser({
      ...user,
      leadSourceDetail: additionalText,
    })
  }
  const handleSubmit = () => {
    if (validForm()) {
      console.log(user)
      nextStep()
    }
  }

  useEffect(() => {
    const nextCheck = () => {
      if (!user.findAFacility || !user.leadSource) {
        setNextbtn(false)
      } else if (
        leadSourceWithInput.includes(user.leadSource) &&
        (!user.leadSourceDetail || user.leadSourceDetail.trim() === "")
      ) {
        setNextbtn(false)
      } else {
        setNextbtn(true)
      }
      if (user.findAFacility === "East Bay, CA") {
        user.findAFacility = "Marin, CA"
      } else if (user.findAFacility === "Inland Empire, CA") {
        user.findAFacility = "Carlsbad, CA"
      }
    }

    nextCheck()
  }, [user])

  useEffect(() => {
    if (user.leadSource) {
      setShowOtherInput(leadSourceWithInput.includes(user.leadSource))
    }
  }, [user.leadSource])

  return (
    <>
      <Layout>
        <section className="progress-bar-section">
          <div className="progress-bar-wrapper">
            <ProgressBar activeStep={0} />
          </div>
        </section>
        <MorningApptBanner />
        <section className="patient-information-section">
          <div className="container">
            <div className="patient-heading">
              <h4>Patient Information</h4>
            </div>
            <form className="patient-formSection" onSubmit={handleSubmit}>
              <div className="patient-wrapper1">
                <div className="patient-form-wrapper">
                  <div className="pat-form-heading">
                    <h4>Nearest Cortica Center</h4>
                  </div>
                  <div className="pat-form-para corticacenterPopup">
                    <p>
                      <span>Why do we ask for this?</span>
                    </p>
                    <div className="ctm-tooltip">
                      <div className="tooltip-header">
                        <h6>
                          <span>
                            <i className="fa-solid fa-question"></i>
                          </span>
                          Why do we need this information?
                        </h6>
                      </div>
                      <div className="tooltip-content">
                        <p>
                          Cortica uses this information to help connect you with
                          the right set of clinicians for you specific needs
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="row align-items-center mt-5">
                    <div className="col-md-12 form-group">
                      <label className="label" htmlFor="selector_facility">
                        Nearest Cortica Center<span>*Required</span>
                      </label>
                      <Select
                        id="selector_facility"
                        name="findAFacility"
                        onChange={handleChange}
                        options={options}
                        placeholder="Choose..."
                        value={options.find(
                          obj => obj.value === user.findAFacility
                        )}
                      />
                    </div>
                    {!user.findAFacility && (
                      <span className="input-error">
                        {errField.findAFacilityErr}
                      </span>
                    )}
                  </div>
                </div>

                <div className="patient-form-wrapper lead-source">
                  <div className="pat-form-heading">
                    <h4>How did you hear about Cortica?</h4>
                  </div>
                  <div className="row align-items-center mt-5">
                    <div className="col-md-12 form-group">
                      <label className="label" htmlFor="selector_lead_source">
                        Select an option<span>*Required</span>
                      </label>
                      <Select
                        id="leadSource"
                        name="leadSource"
                        onChange={handleLeadSource}
                        options={leadSourceOptions}
                        placeholder="Choose..."
                        value={leadSourceOptions.find(
                          obj => obj.value === user.leadSource
                        )}
                      />
                    </div>
                  </div>
                  {!user.leadSource && (
                    <span className="input-error">
                      {errField.leadSourceErr}
                    </span>
                  )}{" "}
                  {showOtherInput && (
                    <div className="row align-items-center">
                      <div className="col-md-12 form-group">
                        <label className="label" htmlFor="leadSourceDetail">
                          Please specify<span>*Required</span>
                        </label>
                        <input
                          className="form-control"
                          id="leadSourceDetail"
                          name="leadSourceDetail"
                          onChange={handleLeadSourceDetail}
                          placeholder="Please provide additional details on how you heard about Cortica"
                          type="text"
                          value={user.leadSourceDetail || ""}
                        />
                      </div>
                      {user.leadSource &&
                        leadSourceWithInput.includes(user.leadSource) &&
                        (!user.leadSourceDetail ||
                          user.leadSourceDetail.trim() === "") && (
                          <span className="input-error">
                            {errField.leadSourceDetailErr}
                          </span>
                        )}
                    </div>
                  )}
                </div>
                <div className=" btn-wrapper mt-4 text-end"></div>
                <div className="btn-wrapper mt-4">
                  <button
                    className="btn btnclose"
                    onClick={prevStep}
                    type="button"
                  >
                    Go Back
                  </button>
                  <ContinueButton disabled={!nextBtn} onClick={handleSubmit}>
                    Next Step
                  </ContinueButton>
                </div>
              </div>
            </form>
          </div>
        </section>
      </Layout>
    </>
  )
}
Corticacenter.propTypes = {
  nextStep: PropTypes.func.isRequired,
  prevStep: PropTypes.func.isRequired,
  setUser: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
}
export default Corticacenter
